export default __webpack_public_path__ + "static/media/Anwesh-Gangula.ee744d13.png";